import moment from "moment";
import { _str_capitalize } from "../../../utils/functions";
import { debounce } from "../../../utils/global";

const INIT_USER_DATA = {
    id: null,
    name: null,
    avatar: null,
};

const REDUCER_ACTIONS = {
    increment: "INCREMENT_MONTH",
    decrement: "DECREMENT_MONTH",
    search_employee_or_teams: "SEARCH_EMPLOYEE_OR_TEAMS",
    show_dialog_employee: "SHOW_DIALOG_EMPLOYEE",
    goto_today: "GOTO_TODAY",
};

const initialCalendar = {
    year: moment().get("year"),
    month: moment().get("month"),
    month_name: _str_capitalize(moment().format("MMMM")),
    search: "",
    show_dialog_employee: {
        user: INIT_USER_DATA,
        visible: false,
    },
};

const reducer = (state, action) => {
    switch (action.type) {
        case REDUCER_ACTIONS.increment: {
            const moment_next_month = moment()
                .set("year", state.year)
                .set("months", state.month + 1);

            const next_month = moment_next_month.get("month");
            const next_year = moment_next_month.year();

            return {
                ...state,
                month: next_month,
                year: next_year,
                month_name: _str_capitalize(moment_next_month.format("MMMM")),
            };
        }
        case REDUCER_ACTIONS.decrement: {
            const moment_next_month = moment()
                .set("year", state.year)
                .set("months", state.month - 1);

            const next_month = moment_next_month.get("month");
            const next_year = moment_next_month.year();

            return {
                ...state,
                month: next_month,
                year: next_year,
                month_name: _str_capitalize(moment_next_month.format("MMMM")),
            };
        }
        case REDUCER_ACTIONS.search_employee_or_teams: {
            return { ...state, search: action.payload };
        }
        case REDUCER_ACTIONS.show_dialog_employee: {
            return {
                ...state,
                show_dialog_employee: {
                    visible: action.payload.visible,
                    user: {
                        id: action.payload.user.id,
                        name: action.payload.user.name,
                        avatar: action.payload.user.avatar,
                    },
                },
            };
        }
        case REDUCER_ACTIONS.goto_today: {
            const today_year = moment().year();
            const today_month = moment().get("month");
            return {
                ...state,
                month: today_month,
                year: today_year,
                month_name: _str_capitalize(moment().format("MMMM")),
            };
        }

        default:
            return state;
    }
};

export const reducer_timeline = {
    reducer,
    initialCalendar,
    REDUCER_ACTIONS,
    INIT_USER_DATA,
};
